import * as React from 'react';
import gql from 'graphql-tag';
import { Listing } from '../rql';
import AffirmEstimateSmall from './affirm_estimate_small';

interface IProps {
  listing: Listing;
}

export const fullFinancingFieldsFragment = gql`
  fragment FullFinancingFields on Listing {
    _id
    estimatedMonthlyPaymentPlan {
      estimatedMonthlyPayment {
        display
      }
      maxTermMonth
      availableTermMonths
      lowestAprAtMaxTerm
      zeroPercentFinancingPlan
    },
    pricing {
      buyerPrice {
        display
      }
    },
  }
`;

function AffirmEstimateListingCardCTA({ listing }: IProps) {
  const { estimatedMonthlyPaymentPlan, pricing } = listing;
  const buyerPrice = pricing?.buyerPrice?.display;

  const emptyRender = !(estimatedMonthlyPaymentPlan?.estimatedMonthlyPayment && buyerPrice);

  if (emptyRender) { return null; }

  const {
    availableTermMonths,
    maxTermMonth,
    lowestAprAtMaxTerm,
    zeroPercentFinancingPlan,
  } = estimatedMonthlyPaymentPlan;

  const estimatedMonthlyPayment = estimatedMonthlyPaymentPlan.estimatedMonthlyPayment.display;

  return (
    <AffirmEstimateSmall
      estimatedMonthlyPayment={estimatedMonthlyPayment}
      buyerPrice={buyerPrice}
      maxTermMonth={maxTermMonth}
      availableTermMonths={availableTermMonths}
      zeroPercentFinancing={zeroPercentFinancingPlan}
      lowestAprAtMaxTerm={lowestAprAtMaxTerm}
    />
  );
}

export default AffirmEstimateListingCardCTA;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/affirm_estimate_listing_card_cta.tsx